import { render, staticRenderFns } from "./ProjectDeveloper.vue?vue&type=template&id=b60c69d8&"
import script from "./ProjectDeveloper.vue?vue&type=script&lang=js&"
export * from "./ProjectDeveloper.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDeveloper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports